import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { api_base, Api_Token } from "../../../env";
import { useAlertContext } from "../../../service/AlertServices";
import { ConfirmDeletePopup } from "../../../composant/Popup/confirmDelete";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";
import { useSelector } from "react-redux";
function HashtagsPage() {
  return <Indexdasbord Children={<Hashtags />} />;
}

const Hashtags = () => {
  const [hashtags, setHashtags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const { user } = useSelector((state) => state.Auth);
  const type = user.idEvent ? "event" : "magasin";
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlertContext();
  const [popupDelete, setPopupDelete] = useState(false);
  const [idDelete, setIdDelete] = useState();
  const [Data, setData] = useState();
  const [popupForm, setPopupForm] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    text: "",
    categories: [],
  });

  const fetchCategories = useCallback(async () => {
    try {
      let url = "";
      if (type === "event") {
        url = `${api_base}CategoryHasTagsRoute/getAllForEvent/${user.idEvent}`;
      } else {
        url = `${api_base}CategoryHasTagsRoute/getAll`;
      }
      const res = await axios.get(url);
      setCategories(res.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des catégories:", error);
    }
  }, [type, user.idEvent]);

  const fetchHashtags = useCallback(async () => {
    setLoading(true);
    try {
      let url =
        type === "event"
          ? `HashTagsRoute/getEventHashtags`
          : `HashTagsRoute/getHashtags`;

      url += `?page=${page + 1}&limit=${rowsPerPage}`;
      if (filterCategory) url += `&filterCategorys=${filterCategory}`;
      if (filterText) url += `&filterText=${filterText}`;

      const response = await Api_Token.get(url);
      setHashtags(response.data.data);
      setData(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des hashtags:", error);
    } finally {
      setLoading(false);
    }
  }, [type, page, rowsPerPage, filterCategory, filterText]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchHashtags();
    }, 2000);

    return () => clearTimeout(delayDebounce);
  }, [fetchHashtags]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${api_base}HashTagsRoute/deleteHashtag/${idDelete}`);
      showAlert("Suppression réussie", "success");
      fetchHashtags();
    } catch (error) {
      console.error("Erreur suppression:", error);
      showAlert("Erreur suppression", "error");
    }
    setPopupDelete(false);
  };

  const handleFormSubmit = async () => {
    try {
      if (formData.id) {
        await axios.put(
          `${api_base}HashTagsRoute/updateHashtag/${formData.id}`,
          formData
        );
        showAlert("Hashtag modifié", "success");
      } else {
        await axios.post(`${api_base}HashTagsRoute/createHashtag`, formData);
        showAlert("Hashtag ajouté", "success");
      }
      setPopupForm(false);
      setFormData({ id: null, text: "", categories: [] });
      fetchHashtags();
    } catch (error) {
      console.error("Erreur formulaire:", error);
      showAlert("Erreur formulaire", "error");
    }
  };

  const EditStar = async (id) => {
    try {
      await axios.put(`${api_base}HashTagsRoute/StarEtat/${id}`);
      showAlert("Hashtag modifié", "success");
      setHashtags((prevHashtags) =>
        prevHashtags.map((tag) =>
          tag.id === id ? { ...tag, star: !tag.star } : tag
        )
      );
    } catch (error) {
      showAlert("Erreur serveur", "error");
    }
  };

  return (
    <Box p={4}>
      <Typography variant="h5" mb={3}>
        Liste des Hashtags
      </Typography>

      <>
        <Paper>
          <Box display="flex" gap={2} mb={2} padding={2}>
            <TextField
              label="Filtrer par texte"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
            <FormControl style={{ minWidth: 200 }}>
              <InputLabel>Catégorie</InputLabel>
              <Select
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
                label="Catégorie"
              >
                <MenuItem value="">Toutes</MenuItem>
                <MenuItem value="sans category">sans category</MenuItem>
                {categories.map((cat) => (
                  <MenuItem key={cat.id} value={cat.name}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setPopupForm(true)}
            >
              Ajouter
            </Button>
          </Box>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <strong>Texte</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Catégories</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Star</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {hashtags.map((tag) => (
                <TableRow key={tag.id}>
                  <TableCell align="center">{tag.text}</TableCell>
                  <TableCell align="center">
                    {tag.Categoryhashtags.map((c) => c.name).join(", ")}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton onClick={() => EditStar(tag.id)}>
                      {tag.star ? (
                        <StarIcon style={{ color: "gold", fontSize: 30 }} />
                      ) : (
                        <StarBorderIcon style={{ fontSize: 30 }} />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        setFormData({
                          id: tag.id,
                          text: tag.text,
                          categories: tag.Categoryhashtags.map((c) => c.id),
                        });
                        setPopupForm(true);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => {
                        setIdDelete(tag.id);
                        setPopupDelete(true);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={Data?.totalItems || 0}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            rowsPerPageOptions={[5, 10, 15]}
          />
        </Paper>

        <Dialog open={popupForm} onClose={() => setPopupForm(false)}>
          <DialogTitle>
            {formData.id ? "Modifier" : "Ajouter"} Hashtag
          </DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label="Texte"
              fullWidth
              value={formData.text}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 20) {
                  setFormData({ ...formData, text: value });
                }
              }}
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Catégories</InputLabel>
              <Select
                multiple
                value={formData.categories}
                onChange={(e) =>
                  setFormData({ ...formData, categories: e.target.value })
                }
              >
                {categories.map((cat) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPopupForm(false)}>Annuler</Button>
            <Button onClick={handleFormSubmit} color="primary">
              {formData.id ? "Modifier" : "Ajouter"}
            </Button>
          </DialogActions>
        </Dialog>

        <ConfirmDeletePopup
          open={popupDelete}
          onClose={() => setPopupDelete(false)}
          confirm={handleDelete}
        />
        <BackLoadingSimple open={loading} />
      </>
    </Box>
  );
};

export default HashtagsPage;
